import React from 'react';
import ImageCarousel from '../components/ImageCarousel'; // Adjust path as needed
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">{t('home.welcomeTitle')}</h1>
          <p className="hero-subtitle mb-8">{t('home.welcomeSubtitle')}</p>
          <div className="flex gap-4 justify-center relative z-10 flex-wrap">
            <Link to="/booking" className="bg-white text-primary px-8 py-3 rounded-full font-label font-bold uppercase tracking-widest hover:bg-secondary hover:text-white transition-all shadow-[0_10px_30px_rgba(0,0,0,0.3)] text-xs md:text-sm">{t('navbar.booking')}</Link>
            <Link to="/prices" className="bg-primary/70 border border-white/30 backdrop-blur-md text-white px-8 py-3 rounded-full font-label font-bold uppercase tracking-widest hover:bg-primary transition-all shadow-[0_10px_30px_rgba(0,0,0,0.3)] text-xs md:text-sm">{t('navbar.prices')}</Link>
            <Link to="/images" className="bg-primary/70 border border-white/30 backdrop-blur-md text-white px-8 py-3 rounded-full font-label font-bold uppercase tracking-widest hover:bg-primary transition-all shadow-[0_10px_30px_rgba(0,0,0,0.3)] text-xs md:text-sm">{t('navbar.images')}</Link>
          </div>
        </div>
        <div className="hero-overlay" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(rgba(0,32,69,0.4), rgba(0,32,69,0.7))',
          zIndex: 1
        }}></div>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, overflow: 'hidden' }}>
          <ImageCarousel fullHeight={true} images={[
            '/images/gallery/IMG_9456.jpg',
            '/images/gallery/IMG_9457.jpg',
            '/images/gallery/IMG_9459.jpg',
            '/images/gallery/IMG_9462.jpg',
            '/images/gallery/IMG_9463.jpg',
            '/images/gallery/IMG_9464.jpg',
            '/images/gallery/IMG_9465-2.jpg',
            '/images/gallery/IMG_9466.jpg'
          ]} />
        </div>
      </section>

      <section className="editorial-section container">
        <div className="asymmetric-grid">
          <div className="editorial-image-wrapper">
            <img src="/images/gallery/IMG_9465-2.jpg" alt={t('imagesPage.alts.garden')} className="editorial-image" />
          </div>
          <div className="editorial-content">
            <span className="section-label">{t('navbar.aboutUs')}</span>
            <h2>{t('home.curatorTitle')}</h2>
            <p>
              {t('home.curatorText1')}
            </p>
            <p>
              {t('home.curatorText2')}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 